import useSWRInfinite from 'swr/infinite';
import { ExternalCalendarEventSummary, FlexCalSummary } from '../types';
import { getFlexStartAndEndDate } from '../helpers/getFlexStartAndEndDate';

const useInfiniteExternalEvents = (
  flexCal: FlexCalSummary,
  setIsReachingEnd: React.Dispatch<React.SetStateAction<boolean>>,
  apiUri: string,
  userId: string
) => {
  const TWO_WEEKS_IN_MILLIS = 1209600000;
  const { start, end } = getFlexStartAndEndDate(flexCal);
  const totalPages = Math.ceil(end.diff(start, ['weeks']).weeks / 2);
  const getKey = (pageIndex: number) => {
    if (pageIndex >= totalPages) {
      return null;
    }
    const addToStart = pageIndex * TWO_WEEKS_IN_MILLIS;
    const addToEnd = addToStart + TWO_WEEKS_IN_MILLIS;
    const endDate = start.plus({ milliseconds: addToEnd });
    const startDate = start.plus({ milliseconds: addToStart });

    const encodedStartDate = encodeURIComponent(
      startDate.toFormat('MM/dd/yyyy, h:mm a')
    );
    const encodedEndDate = encodeURIComponent(
      endDate.toFormat('MM/dd/yyyy, h:mm a')
    );

    return `${apiUri}/users/getExternalEvents/${flexCal.lazyCalendarId}?startDate=${encodedStartDate}&endDate=${encodedEndDate}&userId=${userId}`;
  };
  const { data, error, mutate, size, setSize, isValidating } = useSWRInfinite<
    ExternalCalendarEventSummary[]
  >(getKey, { revalidateFirstPage: false });
  const events = data
    ? ([] as ExternalCalendarEventSummary[]).concat(...data)
    : [];
  const isLoadingInitialData = !data && !error;
  const isLoadingMore =
    isLoadingInitialData ||
    (size > 0 && data && typeof data[size - 1] === 'undefined');
  const isEmpty = data?.[0]?.length === 0;
  const isRefreshing = isValidating && data && data.length === size;
  const currentLoadedPage = data?.length ? data.length : 0;
  return {
    events,
    isLoadingInitialData,
    isLoadingMore,
    isEmpty,
    isRefreshing,
    mutate,
    size,
    setSize,
    currentLoadedPage,
  };
};

export default useInfiniteExternalEvents;
